import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import API from '../../services/api'; // Centralized API service
import Footer from '../layout/Footer';
import Navbar from '../layout/Navbar';

const BlogPostPage = () => {
    const { slug } = useParams(); // Get the 'slug' from the URL
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await API.get(`blog/posts/${slug}/`);
                setPost(response.data);
            } catch (error) {
                console.error("Failed to fetch post:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchPost();
    }, [slug]); // Rerun this effect if the slug changes

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!post) {
        return <div>Post not found.</div>;
    }

    return (
        <div className="bg-white dark:bg-[#141414] text-black dark:text-[#D9D9D9] min-h-screen flex flex-col">
            
            {/* =================================================================
            == META DATA SECTION
            ================================================================= */}
            <title>{post.title} | Trueway Blog</title>
            {/* You can add more specific meta tags here */}

            <Navbar />

            {/* =================================================================
            == MAIN CONTENT SECTION
            ================================================================= */}
            <main className="flex-grow pt-24 pb-12 px-4 sm:px-8">
                <article className="max-w-3xl mx-auto">
                    <Link to="/blog" className="group mt-6 mb-8 flex items-center gap-2 py-1 rounded-md text-sm font-normal text-blue-600 dark:text-[#7DD3FC]">
                        &larr; Back to all posts
                    </Link>

                    {post.featured_image && <img src={post.featured_image} alt={post.title} className="w-full h-96 object-cover rounded-lg mb-8" />}

                    <h1 className="text-4xl sm:text-5xl font-bold text-black dark:text-gray-100 mb-6">{post.title}</h1>

                    {/* =================================================================
                    == AUTHOR INFO SECTION
                    ================================================================= */}
                    <div className="flex items-center mb-8">
                        <img src={post.author.avatar} alt={`${post.author.first_name} ${post.author.last_name}`} className="w-10 h-10 rounded-full mr-3 bg-gray-200 dark:bg-gray-700 object-cover" />
                        <div>
                            <p className="text-sm font-medium text-gray-900 dark:text-[#D9D9D9]">{post.author.first_name} {post.author.last_name}</p>
                            <p className="text-sm text-gray-600 dark:text-[#A3A3A3]">
                                {new Date(post.created_on).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                            </p>
                        </div>
                    </div>

                    {/* =================================================================
                    == BLOG CONTENT SECTION
                    ================================================================= */}
                    <div
                        className="prose prose-lg dark:prose-invert max-w-none"
                        dangerouslySetInnerHTML={{ __html: post.content }}
                    />
                </article>
            </main>
            
            <Footer />
        </div>
    );
};

export default BlogPostPage;